const theme = {
  // 1. 颜色配置：完全匹配企业官网风格
  colors: {
    primary: '#0099ff',    // 品牌主色：蓝色
    secondary: '#ff0000',  // 辅助色：红色
    background: '#ffffff', // 背景色：白色
    text: '#333333',       // 主文本色：深灰
    textLight: '#666666',  // 次要文本色：浅灰
    border: '#eaeaea',     // 边框色
  },

  // 2. 字体配置
  fonts: {
    primary: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },

  // 3. 间距配置（统一页面布局）
  spacing: {
    section: '4rem 0',     // 模块上下间距
    container: '0 2rem',    // 容器左右内边距
  },

  // 4. 阴影配置
  shadows: {
    card: '0 2px 8px rgba(0, 0, 0, 0.05)',
    cardHover: '0 4px 16px rgba(0, 0, 0, 0.1)',
  },

  // 5. 混合样式（解决 Footer 报错的关键！）
  mixins: {
    flexCenter: `
      display: flex;
      justify-content: center;
      align-items: center;
    `,
    flexBetween: `
      display: flex;
      justify-content: space-between;
      align-items: center;
    `,
    flexColumn: `
      display: flex;
      flex-direction: column;
    `,
  },
};

export default theme;